import { render } from "./Organisation.ListDatatable.vue?vue&type=template&id=bd80b6d2"
import script from "./Organisation.ListDatatable.vue?vue&type=script&lang=js"
export * from "./Organisation.ListDatatable.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__